import React, {useMemo, useState, useEffect, Fragment, Suspense, lazy} from 'react';
/* import router */
import { Switch,Route,useHistory , useLocation} from "react-router-dom";
/* ICons */
import {ChevronLeft ,  AccountCircle, ExitToApp , Menu} from '@material-ui/icons';
/* COMPONENTS */
import clsx from 'clsx';
import Drawer from "@material-ui/core/Drawer"
import AppBar from "@material-ui/core/AppBar"
import Toolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"
import Divider from "@material-ui/core/Divider"
import IconButton from "@material-ui/core/IconButton"
//import Badge from "@material-ui/core/Badge"
import Container from "@material-ui/core/Container"
import Grid from "@material-ui/core/Grid"
/* here comes loader */
import Loader from "react-loader-spinner"
/* importing custom styles */
import {useStylesApp} from "theme/styles"
/* importing links */
import {
    MainListItems,
    DriverListItems,
    RiderListItems,
    BookingListItems,
    HomeListItems,
    TripListItems,
    CommunicationListItems, AdditionalPagesListItems , OperationalListItems
} from "components/navigation/ListItems"
import {Hidden, ListItemIcon, MenuItem, Menu as MenuDrawer, Box, Snackbar} from '@material-ui/core';

import Login from "components/Auth/Login"

import { UserContext } from 'UserContext';
import {useDispatch, useSelector} from "react-redux";
import {fetchDashboardUsers, loginUser} from "./app/actions/actions";
import SnackbarCompounent from "./helpers/SnackBarCompounent";

const Coupon = lazy(()=> import('components/Coupon/Coupon'));
const Booking = lazy(() => import('components/Booking/Booking'));
const Trips = lazy(() => import('components/Trips/Trips'));
const DriversBannedList = lazy(() => import('components/Drivers/DriversBannedList'));
const DriversInfo = lazy(() => import('components/Drivers/DriversInfo'));
const SubDrivers = lazy(() => import('components/Drivers/SubDrivers'));
const RidersInfo = lazy(() => import('components/Riders/RidersInfo'));
const NotFound = lazy(() => import('components/Errors/NotFound'));
const DropPoints = lazy(() => import('components/Map/DropPoints'));
const DriverFAQ = lazy(() => import('components/Drivers/DriverFAQ'));
const RiderFAQ = lazy(() => import('components/Riders/RiderFAQ'));
const TimeSlot = lazy(() => import('components/TimeSlot/TimeSlot'));
// const Lines = lazy(() => import('components/Lines/Lines'));
const Lines = lazy(()=>import('components/Lines/Lines'));
const LinesRequests=lazy(()=>import('components/Lines/LinesRequests'))
const CancelBooking = lazy(() => import('components/Booking/CancelBooking'));
const CancellationTrip = lazy(() => import('components/Trips/CancellationTrip'));
const Payement = lazy(() => import('components/payement/Payement'));
const Landing = lazy(() => import('components/Landing/Landing'));
const DashboardUsers = lazy(()=>import('components/additional/DashboardUsers'));
const AnalyticsDashboard = lazy(()=>import('components/additional/AnalyticsDashboard'));
const StatisticsSystem = lazy(()=>import('components/additional/StatisticsSystem'));
const StatisticsDashboard = lazy(()=>import('components/additional/StatisticsDashboard'));
const Logs = lazy(()=>import('components/additional/Logs'));
const CodePromo= lazy(()=>import('components/Communication/CodePromo'));
const NotificationPush= lazy(()=>import('components/Communication/NotificationPush'));
const NotificationPushLogs = lazy(()=>import('components/Communication/NotificationPushLogs'));
// const CodePromo = lazy(()=>import('components/Communication/CodePromo'));
// const NotificationPushLogs = lazy(()=>import('components/Communication/NotificationPushLogs'));
const CodePromoLogs = lazy(()=>import('components/Communication/CodePromoLogs'));
const ContactUsAnswers = lazy(()=>import('components/Communication/ContactUsAnswers'));
const DriverEmployee = lazy(()=>import('components/Drivers/DriverEmployee'));
const BookingRequest = lazy(()=>import('components/Booking/BookingRequest'));
const DriversOperational=lazy(()=>import('components/Operational/DriversOperational'));
const StreetRiders=lazy(()=>import('components/Operational/StreetRiders'));
const SmsGateway= lazy(()=>import('components/Communication/SmsGateway'));










// import { NotificationPush  , Booking , Trips , DriversBannedList , DriversInfo , SubDrivers , RiderFAQ  , RidersInfo , NotFound , DropPoints , Lines , DriverFAQ , Landing , Payement , CancelBooking , CancellationTrip , TimeSlot , AnalyticsDashboard , Logs , StatisticsDashboard , StatisticsSystem , UserDashboard , CodePromo , CodePromoLogs , ContactUsAnswers.js , NotificationPushLogs , BookingRequests , DriverEmp}  from "bundles" ;



const renderLoader = () => {
  return(
    <Loader 
      type="BallTriangle"
      color="#FFDD00"
      height={150}
      width={150}
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding : 'auto',
        position : 'fixed' ,
        left:"0px",
        top: "0px",
        width: "100%",
        height: "100%",   
      }}
    />
  )
}



 
/* RFCE */
export default function App() {
  /* History Instance */
  let history = useHistory () ; 
  let routeLocation = useLocation (); 
  let locationPathName = routeLocation.pathname;
  /* styles */
  const classes = useStylesApp();
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  /* Token authentification */
  /* removing local storage here */
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [mail , setMail]=useState(localStorage.getItem('mail'));
  const [authJson , setAuthJson] = useState(JSON.parse(localStorage.getItem('authorities')))
  const providerToken = useMemo(()=>({token , setToken}) , [token , setToken]);



  /* Handling Loader app */
  const [spinner, setSpinner] = useState(true);//true

  const [containerVisibility , setVisibility] = useState("hidden");//hidden

  /* Profile menu */
  const [anchorEl, setAnchorEl] = React.useState(null);

  /* Handling Navigation */
  const [open, setOpen] = useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  /* const setting up token temporary*/
  /* const settingToken = async () => {
    await setToken(localStorage.getItem('token'));
  }; */

  
 
  /* react hook */

  useEffect(() => {
    setTimeout(() => setSpinner(false), 800);
    if(!spinner)
      setVisibility("visible")  
    
    setTimeout(() => {
      localStorage.clear()
      setToken()
      history.push('/login')
    }, 59 * 60000);//this will be 59 minutes
  }, [spinner , history]);

  const dispatch = useDispatch() ;
  let roles=[];
  let rolesWrite=[];

    if(authJson ){
      authJson.forEach((authority)=>{
          roles[authority.entity]= authority.has.read;
      });
      authJson.forEach((authority)=>{
          rolesWrite[authority.entity]= authority.has.write;
      });
  }

  useEffect(()=>{
      setAuthJson(JSON.parse(localStorage.getItem('authorities')));
      // window.location.reload(false);
  } , [dispatch ,token])

  useEffect(()=>{
      console.log('BACKEND URL =', process.env.REACT_APP_API_URL_STAGING)
  });



 const SideBar = (props) => {
     const roles={};
     const rolesWrite={};
    if(props.roles){
        props.roles.forEach((authority)=>{
            roles[authority.entity]= authority.has.read;
            // roles[authority.entity]= true;
        });
        props.roles.forEach((authority)=>{
            rolesWrite[authority.entity]= authority.has.write;
            // rolesWrite[authority.entity]= true;
        });
    }



     return (
    <Drawer
      variant={props.variantDrawer}
      classes={{
        paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
      }}
      open={open}
    >
      <div className={classes.toolbarIcon}>

        <IconButton color="primary" onClick={(e) => handleDrawerClose(e)} aria-label="close drawer">
          <ChevronLeft />
        </IconButton>

      </div>
      <Divider />
        {/* <List>{<HomeListItems routerHook={history} listItemColor={classes.list_items} />}</List> */}
 
        <HomeListItems  pathName={locationPathName}  listItemColor={classes.list_items} />
      <Divider />
        <MainListItems roles={roles} pathName={locationPathName} listItemColor={classes.list_items} />
      <Divider  />
        <BookingListItems roles={roles} pathName={locationPathName} listItemColor={classes.list_items} />
      <Divider  />
        <TripListItems roles={roles} pathName={locationPathName} listItemColor={classes.list_items} />
      <Divider />
        <DriverListItems roles={roles} pathName={locationPathName} listItemColor={classes.list_items}/>
      <Divider  />
        <RiderListItems roles={roles} pathName={locationPathName} listItemColor={classes.list_items} />
      <Divider />
      <Divider/>
       <OperationalListItems roles={roles} pathName={locationPathName} listItemColor={classes.list_items}/>
      <Divider/>
        <CommunicationListItems roles={roles} pathName={locationPathName} listItemColor={classes.list_items}/>
      <Divider />
        <AdditionalPagesListItems roles={roles} pathName={locationPathName} listItemColor={classes.list_items}/>
    </Drawer>

   )
 }
  

 
 
  return (
    <Fragment>
      <UserContext.Provider value={providerToken}>
      {/* checking token */}
      {
        !localStorage.getItem('token')?
          (
            <Switch>
              <Route exact path="/" component={ () => <Login  /> } /> 
              <Route path="/login" component={ () => <Login   />} />  
              {/* <Route path="/register" component={ () => <Register   />} /> */}  
              <Route path="*" component={() => <NotFound fixedHeightPaper={fixedHeightPaper}/>} />
            </Switch> 
          ):
          (
            <>
              {/* LOADER */}
              <Loader 
                type="BallTriangle"
                color="#FFDD00"
                height={150}
                width={150}
                className={classes.loader}
                visible={spinner}
              />
              {/* Main Container App */}
              <div className={classes.root} style ={{visibility:containerVisibility}} >
                {/* TOP NAV BAR */}
                <AppBar position="absolute" variant="elevation" className={clsx(classes.appBar, open && classes.appBarShift)} >
                  <Toolbar className={classes.toolbar}>
                    <IconButton
                      edge="start"
                      color="secondary"
                      aria-label="open drawer"
                      onClick={handleDrawerOpen}
                      className={clsx(classes.menuButton, open && classes.menuButtonHidden)}
                    >
                      <Menu />
                    </IconButton>
                  

                    <Hidden only={['sm', 'xs']}>
                      <Typography  variant="h5" color="secondary" noWrap className={classes.title}>
                        <Box letterSpacing={6} >
                          ADSIL DASHBOARD
                        </Box>
                      </Typography>
                    </Hidden>
                    <Hidden only={['md', 'lg', 'xl']}>
                      <Typography  variant="h6" color="secondary" noWrap className={classes.title}>
                        <Box letterSpacing={2} >
                          ADSIL DASHBOARD
                        </Box>
                      </Typography>
                    </Hidden>


                    {/*<IconButton color="secondary" aria-label="open notification">
                        <Badge badgeContent={4} color="error">
                          <Notifications />
                        </Badge>
                      </IconButton> */}


                    <IconButton aria-controls="profile-menu" aria-haspopup="true" color="secondary" aria-label="open profile" onClick={(event)=>setAnchorEl(event.currentTarget)} >  
                      <AccountCircle/>
                    </IconButton>

                    <MenuDrawer
                      id="profile-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={()=> setAnchorEl(null)}
                      style={{marginTop:"2rem"}}
                    >
                      <MenuItem onClick={()=>{
                        localStorage.clear()
                        setToken()
                        setAnchorEl(null)
                        history.push("/login")
                      }}>
                        <ListItemIcon>
                          <ExitToApp fontSize="small" />
                        </ListItemIcon>
                        <Typography variant="inherit">Logout</Typography>
                      </MenuItem>
                    </MenuDrawer>


                  </Toolbar>
                </AppBar>
                {/* SIDE BAR */}
                <Hidden only={['sm', 'xs']}>
                  <SideBar roles={authJson}  variantDrawer="permanent" />
                </Hidden>
                <Hidden only={['md', 'lg', 'xl']}>
                <SideBar roles={authJson}  variantDrawer="temporary" />
                </Hidden>
                          
                  {/* CONTAINER child _ here comes all other components */}
                  {/* CONTEXT PROVIDER */}
                    <main className={classes.content}>
                      <div className={classes.appBarSpacer} />
                        <Container maxWidth="xl" className={classes.container}>
                          <Grid container spacing={3}>
                            <Suspense fallback={renderLoader()}>

                              <Switch>
                                {/* LANDING */}
                                <Route 
                                  exact path="/" 
                                  component={() => <Landing  />}     
                                />
                                {/*GENERAL */}
                                  <Route
                                      path="/general/timeSlot"
                                      component={() => <TimeSlot write={rolesWrite.timeslots}  />}
                                  />
                                  <Route
                                      path="/general/lines"
                                      component={() => <Lines write={rolesWrite.lines } />}
                                  />
                                  <Route
                                      path="/general/linesRequests"
                                      component={() => <LinesRequests write={rolesWrite.lines } />}
                                  />

                                  <Route
                                      path="/general/dropPoints"
                                      component={() => <DropPoints write={rolesWrite.points  }  />}
                                  />
                                  <Route
                                      path="/general/payement"
                                      component={() => <Payement write={rolesWrite.payments  }  />}
                                  />
                                {/*  TRIPS */}
                                <Route 
                                  exact
                                  path="/trips" 
                                  component={() => <Trips write={rolesWrite.trips } />}
                                />  
                                <Route 
                                  path="/trips/cancellations"
                                  component={() => <CancellationTrip write={rolesWrite.tripCancellationReasons }  />}
                                />
                                {/*BOOKING*/}
                                <Route
                                    exact
                                  path="/booking" 

                                  component={() => <Booking write={rolesWrite.bookings  }  />}
                                />
                                <Route 
                                  path="/booking/cancellations"
                                  component={() => <CancelBooking write={rolesWrite.bookingCancellationReasons } />}
                                />
                                  <Route
                                      path="/booking/bookingRequest"
                                      component={() => <BookingRequest write={rolesWrite.bookingRequests }  />}
                                  />

                                {/* DRIVERS  */}

                                <Route
                                  path="/drivers/info_list" 
                                  component={() => <DriversInfo write={rolesWrite.functionalDrivers}  />}
                                />
                                <Route
                                  path="/drivers/subscription" 
                                  component={() => <SubDrivers write={rolesWrite.subscribedDrivers }  />}
                                />
                                <Route
                                  path="/drivers/baned_list" 
                                  component={() => <DriversBannedList write={rolesWrite.blockedDrivers }  />}
                                />
                                  <Route
                                      path="/drivers/driverEmployee"
                                      component={() => <DriverEmployee write={rolesWrite.employeeDriver  }  />}
                                  />
                                  <Route
                                  path="/drivers/driverFAQsAdmin"
                                  component={() => <DriverFAQ write={rolesWrite.driverFAQ  } />}
                                />

                                {/* RIDERS */}
                                <Route
                                  path="/riders/info_list" 
                                  component={() => <RidersInfo write={rolesWrite.riders   }  />}
                                />
                                
                                <Route
                                  path="/riders/riderFAQsAdmin"
                                  component={() => <RiderFAQ write={rolesWrite.ridersFAQ   } />}
                                />
                                {/*OPERATIONAL*/}
                                  <Route
                                      path="/operational/drivers"
                                      component={() => <DriversOperational  write={true}/>}
                                  />


                                  <Route
                                      path="/operational/streetRiders"
                                      component={() => <StreetRiders write={true}  />}
                                  />

                                {/* COMMUNICATION  */}

                                <Route
                                    exact
                                  path="/communication"
                                  component={() => <NotificationPush />}
                                />


                                <Route
                                    exact
                                  path="/communication"
                                  component={() => <NotificationPush  write={rolesWrite.notificationPush  }/>}
                                />


                                <Route
                                  path="/communication/codePromo"
                                  component={() => <CodePromo write={rolesWrite["code promo"] }  />}
                                />

                                <Route
                                  path="/communication/codePromoLogs"
                                  component={() => <CodePromoLogs write={true} />}
                                />


                                <Route
                                  path="/communication/contactUsAnswers"
                                  component={() => <ContactUsAnswers write={rolesWrite.contactUs } />}
                                />

                                <Route
                                  path="/communication/notificationPushLogs"
                                  component={() => <NotificationPushLogs write={true} />}
                                />
                                  <Route
                                      path="/communication/smsGateway"
                                      component={() => <SmsGateway write={true} />}
                                  />

                                  {/*ADDITIONAL*/}


                                  <Route
                                    exact
                                  path="/additionalPages"
                                  component={() => <AnalyticsDashboard write={true} />}
                                />


                                <Route
                                  path="/additionalPages/statisticsSystem"
                                  component={() => <StatisticsSystem write={true} />}
                                />

                                <Route
                                  path="/additionalPages/statisticsDashboard"
                                  component={() => <StatisticsDashboard write={true} />}
                                />

                                <Route
                                  path="/additionalPages/logs"
                                  component={() => <Logs write={rolesWrite.logs  } />}
                                />


                                <Route
                                  path="/additionalPages/dashboardUsers"
                                  component={() => <DashboardUsers history={history} write={rolesWrite.dashboardUsers} />}
                                  />


                                <Route path="*" component={() => <NotFound fixedHeightPaper={fixedHeightPaper}/>} />
                              </Switch>
                                <SnackbarCompounent/>

                            </Suspense>
                          </Grid>
                        </Container>
                    </main>
              </div>

            </>
          )
      }

    </UserContext.Provider>
    </Fragment>
    
  );
}